var map = {
	"./": 18305,
	"./App": 9555,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./assets/fonts/Barlow-Bold.ttf": 4081,
	"./assets/fonts/Barlow-Regular.ttf": 39666,
	"./assets/fonts/SF TransRobotics Bold Italic.ttf": 23843,
	"./assets/fonts/SF TransRobotics Bold.ttf": 94939,
	"./assets/fonts/SF TransRobotics Extended Bold Italic.ttf": 81136,
	"./assets/fonts/SF TransRobotics Extended Bold.ttf": 10460,
	"./assets/fonts/SF TransRobotics Extended Italic.ttf": 63951,
	"./assets/fonts/SF TransRobotics Extended.ttf": 18502,
	"./assets/fonts/SF TransRobotics Italic.ttf": 94760,
	"./assets/fonts/SF TransRobotics.ttf": 55182,
	"./assets/fonts/Saira-Bold.ttf": 38055,
	"./assets/fonts/Saira-ExtraBold.ttf": 97131,
	"./assets/fonts/Saira-Medium.ttf": 51679,
	"./assets/fonts/Saira-Regular.ttf": 76980,
	"./assets/images/about-us-img.webp": 33662,
	"./assets/images/banner-icon.png": 16481,
	"./assets/images/burger_bg.png": 6121,
	"./assets/images/ch-1.webp": 85978,
	"./assets/images/ch-2.webp": 93714,
	"./assets/images/clean-road-map.webp": 7518,
	"./assets/images/desktop/about-us-bg.webp": 40942,
	"./assets/images/desktop/bg-1.png": 7401,
	"./assets/images/desktop/bg-2.png": 79692,
	"./assets/images/desktop/en/banner-1.png": 98313,
	"./assets/images/desktop/en/banner-2.png": 23414,
	"./assets/images/desktop/id/banner-1.png": 18889,
	"./assets/images/desktop/id/banner-2.png": 33934,
	"./assets/images/desktop/th/banner-1.png": 28066,
	"./assets/images/desktop/th/banner-2.png": 56394,
	"./assets/images/desktop/vn/banner-1.png": 23502,
	"./assets/images/desktop/vn/banner-2.png": 63959,
	"./assets/images/easy-to-use.webp": 97548,
	"./assets/images/exclusive-csgo.png": 27089,
	"./assets/images/exclusive-dotatreasure.png": 71006,
	"./assets/images/exclusive-kogdraw.png": 56174,
	"./assets/images/exclusive-loldraft.png": 20702,
	"./assets/images/feature-device.png": 84329,
	"./assets/images/feature-icon-1.png": 8081,
	"./assets/images/feature-icon-2.png": 49498,
	"./assets/images/feature-icon-3.png": 53990,
	"./assets/images/feature-icon-4.png": 71070,
	"./assets/images/feature-icon-5.png": 31431,
	"./assets/images/feature-icon-6.png": 71477,
	"./assets/images/flag-en.png": 44292,
	"./assets/images/flag-zh.png": 3056,
	"./assets/images/flags/br.svg": 96459,
	"./assets/images/flags/de.svg": 60264,
	"./assets/images/flags/en.svg": 37269,
	"./assets/images/flags/es.svg": 1771,
	"./assets/images/flags/id.svg": 39627,
	"./assets/images/flags/jp.svg": 60807,
	"./assets/images/flags/kr.svg": 52771,
	"./assets/images/flags/ms.svg": 21998,
	"./assets/images/flags/ru.svg": 31561,
	"./assets/images/flags/th.svg": 59341,
	"./assets/images/flags/tr.svg": 36686,
	"./assets/images/flags/vn.svg": 35869,
	"./assets/images/flags/zh.svg": 20181,
	"./assets/images/header-logo.webp": 8876,
	"./assets/images/lootbox-bg.jpg": 15069,
	"./assets/images/mobile/bg-1.png": 47509,
	"./assets/images/mobile/bg-2.png": 74361,
	"./assets/images/mobile/en/banner-1.png": 65232,
	"./assets/images/mobile/en/banner-2.png": 48129,
	"./assets/images/mobile/id/banner-1.png": 16924,
	"./assets/images/mobile/id/banner-2.png": 76709,
	"./assets/images/mobile/th/banner-1.png": 2331,
	"./assets/images/mobile/th/banner-2.png": 65692,
	"./assets/images/mobile/vn/banner-1.png": 44238,
	"./assets/images/mobile/vn/banner-2.png": 6809,
	"./assets/images/services-1.png": 70680,
	"./assets/images/services-2.png": 92467,
	"./assets/images/services-3.png": 74006,
	"./assets/images/services-4.png": 66524,
	"./assets/images/services-5.png": 94720,
	"./assets/images/services-6.png": 23116,
	"./assets/images/services-7.png": 11206,
	"./assets/images/services-8.png": 93530,
	"./assets/images/weekly-jackpot.webp": 80631,
	"./components/footer": 37501,
	"./components/footer.js": 37501,
	"./components/header": 17250,
	"./components/header/": 17250,
	"./components/header/index": 17250,
	"./components/header/index.js": 17250,
	"./components/header/lang-switcher": 50593,
	"./components/header/lang-switcher.js": 50593,
	"./components/header/logo": 69228,
	"./components/header/logo.js": 69228,
	"./components/header/mobile": 35441,
	"./components/header/mobile.js": 35441,
	"./components/sections/about-us": 53706,
	"./components/sections/about-us.js": 53706,
	"./components/sections/banner": 56488,
	"./components/sections/banner/": 56488,
	"./components/sections/banner/index": 56488,
	"./components/sections/banner/index.js": 56488,
	"./components/sections/banner/mobile": 8368,
	"./components/sections/banner/mobile.js": 8368,
	"./components/sections/contact-us": 26306,
	"./components/sections/contact-us.js": 26306,
	"./components/sections/exclusive": 65574,
	"./components/sections/exclusive.js": 65574,
	"./components/sections/features": 68492,
	"./components/sections/features.js": 68492,
	"./components/sections/games": 1530,
	"./components/sections/games.js": 1530,
	"./components/sections/lootbox": 13048,
	"./components/sections/lootbox.js": 13048,
	"./components/sections/services": 34568,
	"./components/sections/services.js": 34568,
	"./hooks/useDimensionsTracker": 15183,
	"./hooks/useDimensionsTracker.js": 15183,
	"./hooks/useGAEventsTracker": 64076,
	"./hooks/useGAEventsTracker.js": 64076,
	"./hooks/useScrollSpy": 63455,
	"./hooks/useScrollSpy.js": 63455,
	"./i18nextConf": 68107,
	"./i18nextConf.js": 68107,
	"./index": 18305,
	"./index.js": 18305,
	"./layouts": 59425,
	"./layouts/": 59425,
	"./layouts/index": 59425,
	"./layouts/index.js": 59425,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./router": 916,
	"./router/": 916,
	"./router/index": 916,
	"./router/index.js": 916,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./styles/404.scss": 82098,
	"./styles/demo.scss": 61242,
	"./styles/fonts.scss": 43754,
	"./styles/footer.scss": 40653,
	"./styles/general.scss": 22943,
	"./styles/header.scss": 40086,
	"./styles/header_mobile.scss": 24148,
	"./styles/index.scss": 25439,
	"./styles/reset.scss": 43676,
	"./styles/sections/about-us.scss": 1270,
	"./styles/sections/banner.scss": 60830,
	"./styles/sections/contact.scss": 97018,
	"./styles/sections/exclusive.scss": 52993,
	"./styles/sections/features.scss": 15607,
	"./styles/sections/games.scss": 69311,
	"./styles/sections/lang-switcher.scss": 33723,
	"./styles/sections/lootbox.scss": 87333,
	"./styles/sections/services.scss": 70292,
	"./utils/constant": 64879,
	"./utils/constant/": 64879,
	"./utils/constant/index": 64879,
	"./utils/constant/index.js": 64879,
	"./utils/constant/keyframes": 16462,
	"./utils/constant/keyframes.js": 16462,
	"./utils/helpers": 80274,
	"./utils/helpers/": 80274,
	"./utils/helpers/index": 80274,
	"./utils/helpers/index.js": 80274,
	"./views/404": 64161,
	"./views/404.js": 64161,
	"./views/demo": 90938,
	"./views/demo.js": 90938,
	"./views/home": 26637,
	"./views/home.js": 26637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;